import L from 'leaflet';
import {
    LayersControl,
    MapContainer,
    ScaleControl,
    TileLayer,
    ZoomControl
} from "react-leaflet";
import 'leaflet/dist/leaflet.css'
import './Map.css';
import React, {useEffect, useState, useMemo} from "react";
import {MainNavBar} from "../MainNavBar/MainNavBar";
import {Header} from "../Header/Header";
import {MouseCoordinates} from "../Info/Coordinates";
import {TimeLine} from "../TimeLine/TimeLine";
import {Ruler} from './Ruler/Ruler.jsx'
import { Context } from "./Context";
import {MutableImageOverlay} from "./MutableImageOverlay";
import {MarkersLayer} from "./MarkersLayer/markersLayer";
import axios from "axios";

import {CounrtyBorders} from "./layers/countryBorders";
import {NatureReserves} from "./layers/NatureReservesBorders";
import {Settlements} from "./layers/localities";
import {ModalReportPDF} from "../MainNavBar/reportModal/ModalPDF";
import {ModalReportSHP} from "../MainNavBar/reportModal/ModalSHP";
import {enableMapDragging} from "./MapEvents/MapEvents";

import {layersDict, URL_FOR_MARKS, imageSettings} from "../../config/config";
import loader from '../../icons/loading-loading-forever.gif'
import "./Map.css"

export function MapComponent(){
    const [context, setContext] = useState(Context);
    const center = L.latLng(65.505, 106.09)
    const [map,setMap] = useState(null)

    const [SHPModalActive, setSHPModalActive] = useState(false)
    const [PDFModalActive, setPDFModalActive] = useState(false)

    const [baseLayer,setBaseLayer] = useState(layersDict[0].url);
    const [compositeForImage,setCompositeForImage] = useState(imageSettings[0].composite)

    const [showImageOverlay, setShowImageOverlay] = useState(false);
    const [showMarkers,setShowMarkers] = useState(false);
    const [showBorders,setShowBorders] = useState(false);
    const [showNatureReserves, setShowNatureReserves] = useState(false);
    const [showSuomiNPPImageOverlay,setShowSuomiNPPImageOverlay] = useState(false);
    const [showNOAAImageOverlay, setShowNOAAImageOverlay] = useState(false);
    const [showNOAA21ImageOverlay, setShowNOAA21ImageOverlay] = useState(false);

    const MemoizedTimeline = useMemo(()=> TimeLine,[context]);
    const MemoizedChildComponentMark_render = useMemo(() => MarkersLayer, [context])

    const [infoAboutMarks, setInfoAboutMarks] = useState();
    const [settLementShow, setSettLementShow] = useState(false);

    const [brightnessValue,setBrightnessValue] = useState(0)
    const [contrastValue, setContrastValue] = useState(0)

    // Запрос информации о днях с точками
    const requestForInfoWhenMapIsReady = () => {
        axios.get(URL_FOR_MARKS.URL_GET_INFO)
            .then(response => {
                setInfoAboutMarks(response.data.date)
            })
            .catch(error => {
                console.error("Ошибка при получении информации о точках:", error)
            })
    }

    useEffect(()=>{
        requestForInfoWhenMapIsReady();
    },[])

    const modalSHP = () => setSHPModalActive(true)
    const modalPDF = () => setPDFModalActive(true)
    const settLement = () => setSettLementShow(!settLementShow)

    const borders = () => setShowBorders(!showBorders)
    const NOAAImageOverlay = () => {
        setShowNOAAImageOverlay(!showNOAAImageOverlay)
        setShowSuomiNPPImageOverlay(false)
        setShowNOAA21ImageOverlay(false)
    }
    const NOAA21ImageOverlay = () => {
        setShowNOAA21ImageOverlay(!showNOAA21ImageOverlay)
        setShowSuomiNPPImageOverlay(false)
        setShowNOAAImageOverlay(false)
    }
    const SuomiImageOverlay = () => {
        setShowNOAAImageOverlay(false)
        setShowNOAA21ImageOverlay(false)
        setShowSuomiNPPImageOverlay(!showSuomiNPPImageOverlay);
    }
    const natureReserves = () => setShowNatureReserves(!showNatureReserves)
    const markers = () => setShowMarkers(!showMarkers)
    const imageOverlay = () => setShowImageOverlay(!showImageOverlay)

    const changeLayer = (layer) => setBaseLayer(layer)
    const changeComposite = (composite) => setCompositeForImage(composite)
    const changeBrightness = (brightness) => setBrightnessValue(brightness)
    const changeContrast = (contrast) => setContrastValue(contrast)

    return <>
        <div onMouseUp={() => enableMapDragging(map)}>
            <MapContainer zoomControl={false} maxZoom={15} zoom={4} minZoom={3}
                          center={center}
                          ref={setMap}
                          whenReady={requestForInfoWhenMapIsReady}
                          doubleClickZoom={false}
                          maxBounds={[[-110, -170], [100, 200]]}>

                <ZoomControl position={'bottomleft'}/>
                <ScaleControl position={"bottomleft"}/>
                <Ruler/>
                <Header map={map}/>
                <MouseCoordinates map={map}/>

                <Context.Provider value={[context, setContext]}>

                    <ModalReportPDF active={PDFModalActive} setActive={setPDFModalActive} map={map}/>
                    <ModalReportSHP active={SHPModalActive} setActive={setSHPModalActive} map={map}/>

                    <MainNavBar map={map}
                                layers={layersDict}
                                layersChange={changeLayer}
                                layersValue={baseLayer}
                                bordersValue={showBorders}
                                natureReservesValue={showNatureReserves}
                                markersValue={showMarkers}
                                SHPmodalValue={SHPModalActive}
                                PDFmodalValue={PDFModalActive}
                                modalPDF={modalPDF}
                                modalSHP={modalSHP}
                                settLementValue={settLementShow}
                                settLementShow={settLement}
                                SuomiValue={showSuomiNPPImageOverlay}
                                SuomiShow={SuomiImageOverlay}
                                NOAAValue={showNOAAImageOverlay}
                                NOAAShow={NOAAImageOverlay}
                                NOAA21Value={showNOAA21ImageOverlay}
                                NOAA21Show={NOAA21ImageOverlay}
                                compositeList={imageSettings}
                                ImageComposite={compositeForImage}
                                compositeChange={changeComposite}
                                contrastChange={changeContrast}
                                contrastValue={contrastValue}
                                brightnessChange={changeBrightness}
                                brightnessValue={brightnessValue}
                                imageValue={showImageOverlay}
                                imageOverlayShow={imageOverlay}
                                NatureReservesShow={natureReserves}
                                markersShow={markers}
                                bordersShow={borders}
                    />

                    <MemoizedTimeline info={infoAboutMarks} map={map}
                                      satelliteSuomi={showSuomiNPPImageOverlay}
                                      satelliteNoaa={showNOAAImageOverlay}
                                      satelliteNoaa21={showNOAA21ImageOverlay}/>

                    <TileLayer url={baseLayer}/>

                    {showNOAAImageOverlay && <MutableImageOverlay noaaShow={showNOAAImageOverlay}
                                                                  composite={compositeForImage}
                                                                  contrast={contrastValue}
                                                                  brightness={brightnessValue}/>}

                    {showNOAA21ImageOverlay && <MutableImageOverlay noaa21Show={showNOAA21ImageOverlay}
                                                                    composite={compositeForImage}
                                                                    contrast={contrastValue}
                                                                    brightness={brightnessValue}/>}

                    {showSuomiNPPImageOverlay && <MutableImageOverlay suomiShow={showSuomiNPPImageOverlay}
                                                                      composite={compositeForImage}
                                                                      contrast={contrastValue}
                                                                      brightness={brightnessValue}/>}

                    {showBorders && <CounrtyBorders/>}
                    {showNatureReserves && <NatureReserves/>}
                    {showMarkers && <MemoizedChildComponentMark_render isActive={showMarkers}/>}
                    {settLementShow && <Settlements map={map}/>}

                </Context.Provider>
            </MapContainer>
        </div>
    </>
}